module.exports = "https://bin.bnbstatic.com/_next/static/images/about-banner-6e05c55798285c766f390560d1cc4886.jpg";